import { Text } from "@/components/ui/baseUi/text"
import { useLanguage } from "@/modules/language/hooks/useLanguage"
import { cn } from "@/modules/lib/utils"
import { getDisplayedScore } from "@/modules/scores/scoreUtils"
import { useUnit } from "@/modules/utils/hooks/useUnit"
import { getModalityTagImage } from "@modules/personalRecords/personalRecord.utils"
import { FavoritePersonalRecordEntity } from "@modules/profile/publicProfile/entities/favoritesPersonalRecord"

type HUFavoritePersonalRecordMiniCardsProps = {
  item: FavoritePersonalRecordEntity
  className?: string
} & React.ComponentProps<"div">

export function HUFavoritePersonalRecordMiniCards({
  item,
  className,
  ...props
}: HUFavoritePersonalRecordMiniCardsProps) {
  const unit = useUnit()
  const language = useLanguage()

  return (
    <div className={cn("flex w-33 flex-col items-center justify-center gap-1 rounded-3xl p-2.5", className)} {...props}>
      {getModalityTagImage(item.movement.modality, 30)}
      {item.personalRecord ? (
        <div className="flex flex-row items-baseline gap-2">
          <Text fontStyle="TM">
            {getDisplayedScore(item.personalRecord.value || 0, null, item.movement.scoreType, false, unit, language)}
          </Text>
        </div>
      ) : null}
      <Text fontStyle="BS">{item.movement.movementName}</Text>
    </div>
  )
}
